import {useState, useEffect} from "react";
import FeaturedChefs from '../components/featured-chefs/chef-sunny';
import OurTeam from '../components/team/our-team-panel';
import JoinUs from "../components/team/join-us-panel";
import {gPageView} from "../google-analytics";

function TeamPage() {
    useEffect(() => {
        gPageView('team');
    }, );
    return (
        <div id="team-page">
            <div className="panel">
                <FeaturedChefs />
                <OurTeam />
                <JoinUs />
            </div>
        </div>
    );
}

export default TeamPage;